module.exports = __webpack_public_path__ + "d85f108d156708739fa67692fee5f0b4.obj";